import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Ionic4DatepickerService {

  isModalOpen = false;

  constructor() { }
}
